module.exports = __webpack_public_path__ + "img/b.9329cf29.jpg";